export { getRecipientFilterConfigs } from './filterConfigs';
export { getRecipientColumns } from './tableColumns';
export { getEmailRecipientColumns } from './emailRecipientTableColumns';

/**
 * Pagination constants for recipients
 */
export const RECIPIENTS_PAGE_SIZE = 10;
export const RECIPIENTS_EXPORT_PAGE_SIZE = 1000;
